import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-neutral text-neutral-content" }
const _hoisted_2 = { class: "navbar container mx-auto" }
const _hoisted_3 = { class: "navbar-start" }
const _hoisted_4 = {
  for: "side-drawer",
  class: "btn btn-ghost drawer-button"
}
const _hoisted_5 = { class: "navbar-end" }
const _hoisted_6 = {
  key: 0,
  class: "join"
}
const _hoisted_7 = {
  href: "/account/",
  class: "btn btn-square btn-ghost-underline join-item w-20 normal-case"
}
const _hoisted_8 = {
  key: 1,
  class: "join"
}

import { useBackendStore } from "@/stores";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const backend = useBackendStore();

// Make sure we know which user is logged in
backend.fetchUser();

const logoutUrl = `/account/logout?next=${window.location.pathname}`;
const loginUrl = `/account/login?next=${window.location.pathname}`;
const signupUrl = `/account/signup?next=${window.location.pathname}`;

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createVNode(_component_Icon, {
            icon: "ic:round-menu",
            class: "text-2xl"
          })
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-1" }, [
          _createElementVNode("a", {
            href: "/",
            class: "btn btn-ghost-underline normal-case font-medium text-xl font-serif"
          }, " inscrib.io ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(backend).userLoggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("a", _hoisted_7, " @" + _toDisplayString(_unref(backend).user?.username), 1),
              _createElementVNode("a", {
                href: logoutUrl,
                class: "btn btn-square btn-ghost-underline join-item w-20 normal-case"
              }, " Log out ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("a", {
                href: loginUrl,
                class: "btn btn-square btn-ghost-underline join-item w-20 normal-case"
              }, " Log in "),
              _createElementVNode("a", {
                href: signupUrl,
                class: "btn btn-square btn-ghost-underline join-item w-20 normal-case"
              }, " Sign up ")
            ]))
      ])
    ])
  ]))
}
}

})